<div class="notifications-list">
  <div
    class="header-container d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">Notification Configurations</h5>
    <button
      class="btn btn-primary d-flex align-items-center"
      (click)="onAddNew()">
      <i class="fas fa-plus me-2"></i>Add New Configuration
    </button>
  </div>

  <div class="row g-4 mb-4">
    <div class="col-12" *ngFor="let notification of notifications">
      <div class="card shadow-sm hover-shadow">
        <div class="card-body p-3">
          <div class="d-flex justify-content-between align-items-center">
            <div class="flex-grow-1">
              <div
                class="mb-3 d-flex align-items-center justify-content-between">
                <div class="text-event d-flex align-items-center">
                  <span
                    >{{ notification.workflowContext.event }} ({{
                      getNotificationTypeDisplay(notification.type)
                    }})</span
                  >
                  <span class="ms-2 badge bg-info">{{
                    getEndStateTypeDisplay(
                      notification.workflowContext.endStateType
                    )
                  }}</span>
                </div>
                <div class="action-buttons d-flex gap-2">
                  <button
                    class="btn btn-primary"
                    (click)="onEdit(notification)">
                    <i class="fas fa-edit"></i> Edit
                  </button>
                  <button
                    class="btn"
                    style="color: #757c8a"
                    (click)="onDelete(notification)">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
              <div class="text-states">
                <p class="mb-0">
                  <span>From</span>
                  <strong>{{ notification.workflowContext.startState }}</strong>
                  <span>to</span>
                  <strong>{{
                    notification.workflowContext.endStateCode
                  }}</strong>
                </p>
                <p class="m-0">
                  <span>Action Type: </span>
                  <strong>{{
                    getActionTypeDisplay(
                      notification.workflowContext.actionType
                    )
                  }}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
